import {onReady} from "../../../../modules/vegas/js/util";
import VGCarousel from './carousel';

function enableCarousel() {
	if (App.debug) {
		console.info('init: carousel');
	}

	document.querySelectorAll('.swiper').forEach((carousel) => {
		VGCarousel.init(carousel);
	});
}

onReady(enableCarousel);
typeof onTurboRender !== 'undefined' && onTurboRender(enableCarousel);
